import React from 'react';
import { RichTextEditor } from '../../../../../../core/components/RichTextEditor';
import { preparePostPreview } from './PostTextEditor.helpers';

const PostTextEditor = props => {
  const { isPostLoading, onChange, postContent } = props;

  const handleChange = value => {
    const postPreview = preparePostPreview(value);
    onChange({
      postPreview,
      postContent: value,
    });
  };

  return !isPostLoading ? (
    /** Using a random key to force re-mount of RichTextEditor when initialValue changes (temporary workaround) */
    <RichTextEditor key={Math.random()} initialValue={postContent} onChange={handleChange} />
  ) : (
    'Loading...'
  );
};

export default PostTextEditor;
